<template>
  <div class="bespread-wrap module-layer2">
    <div class="screen-container">
      <div
        class="cnt "
       
      >
        <img
          src="../../assets/img/layer2/bg-role.png"
          alt=""
          srcset=""
          class="lf-role"
        />
        <div class="lr-progress">
          <img
            :src="
              require('../../assets/img/layer2/title/title-' + lang + '.png')
            "
            alt=""
            srcset=""
            class="title"
          />
          <img
            :src="
              require('../../assets/img/layer2/progress/progress-' +
                lang +
                '.png')
            "
            alt=""
            srcset=""
            class="progress-img-size"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  props: ["language"],

  data() {
    return {
      lang: localStorage.getItem("sof_locale") || "en"
    };
  },
  watch: {
    // 监听到父组件传递过来的数据后，加工一下，
    // 存到data中去，然后在页面上使用
    language(newVal, oldVal) {
      this.lang = newVal;
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer2 {
  // pointer-events: none;

  .screen-container {
    background-image: url("../../assets/img/layer2/bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .cnt {
      width: 100%;
      height: 100%;
      position: relative;

      .lf-role {
        width: 1696px;
        height: 1737px;
        // top: 100px;
        position: absolute;
        left: -28%;
        top: -8vw;
      }
      .lr-progress {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        right: 6vw;
        top: 4vw;
        .title {
          width: auto;
          height: 240px;
        }
        .progress-img-size {
          margin-top: 1.5vw;
          width: auto;
          height:450px;
        }
        // .pimg-block {
        //   display: block;
        // }

        // .pimg-none {
        //   display: none;
        // }
      }
    }
  }

}
@media screen and (max-width: 1200px) {
  .module-layer2 {
   
   
    .lr-progress {
      top: 10vw !important;
    }
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer2 {
  
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer2.vue